// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__2JR4w","section":"Layout_section__35tf1"};